import { RootState } from '@app/model';

export const selectIsBookCreating = ({ bookCreation: { isBookCreating } }: RootState) => isBookCreating;
